const TRC_CONTENT_MARK_STYLE_CLASSES_MAP = {
    'crossed-out': wordData => wordData.substituted && !wordData.selfCorrected,
    'crossed-out-green': wordData => wordData.substituted && wordData.selfCorrected,
    'round-color': wordData => wordData.omitted && !wordData.selfCorrected,
    'round-color-green': wordData => wordData.omitted && wordData.selfCorrected,
    'green italic': wordData => wordData.selfCorrected,
    sc: wordData => wordData.selfCorrected && wordData.note === null && !wordData.inserted,
    red: wordData => wordData.inserted || wordData.told,
};

export default TRC_CONTENT_MARK_STYLE_CLASSES_MAP;
